export const SALE_OUTLOOK_FIELDS = [
	'saleProbability30d',
	'saleProbability90d',
	'saleProbabilityListings',
	'expectedSaleDays'
]

export const SALE_PROBABILITY_KEYS = ['saleProbability30d', 'saleProbability90d']

const isNumber = (value) => typeof value === 'number' && !Number.isNaN(value)

export const formatSaleProbability = (value, locale) => {
	if (!isNumber(value)) return null
	return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(value)
}

export const formatExpectedSaleDays = (value) => {
	const days = isNumber(value) ? Math.round(value) : null
	return days > 0 ? days : null
}

export const pickSaleOutlook = (source) => {
	if (!source || SALE_OUTLOOK_FIELDS.every((key) => source[key] === undefined)) return null
	return SALE_OUTLOOK_FIELDS.reduce((acc, key) => ({ ...acc, [key]: source[key] ?? null }), {})
}

export const buildSaleOutlookTexts = (outlook, { t, locale }) => {
	const p30 = formatSaleProbability(outlook?.saleProbability30d, locale)
	const p90 = formatSaleProbability(outlook?.saleProbability90d, locale)
	const days = formatExpectedSaleDays(outlook?.expectedSaleDays)
	const hasProbability = p30 !== null || p90 !== null
	const listings = outlook?.saleProbabilityListings
	return {
		p30,
		p90,
		days,
		hasProbability,
		probability: hasProbability
			? t('common.sale-outlook.probability-value', { p30: p30 ?? '–', p90: p90 ?? '–' })
			: null,
		listings: hasProbability && isNumber(listings)
			? t('common.sale-outlook.listings', { count: listings })
			: null,
		expectedDays: days !== null ? t('common.sale-outlook.expected-sale-days-value', { days }) : null,
		typicalDays: days !== null ? t('common.sale-outlook.typical-sale-days', { days }) : null
	}
}
